/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Collation } from './collation';


export interface SortExpression { 
    /**
     * Path to the required resource property.
     */
    property: string;
    /**
     * Direction specifier.
     */
    direction: SortExpressionDirection;
    collation?: Collation | null;
}
export enum SortExpressionDirection {
    Ascending = 'ascending',
    Descending = 'descending'
};



